import React, { Fragment, ReactNode } from "react";
import { StaticContext } from "react-router";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getEduAcvities } from "../../apis/api";
import { ActivityInfo } from "../../models/system";
import { Pager } from "../components/Pager";
import { SubmenuTitle } from "../components/SubmenuTitle";
//@ts-ignore
@withRouter

export class Education extends React.Component<Partial<RouteComponentProps<{ type: string, name: string, key: string }>>> {

    state = { total: 0 as number, page: 0, pageSize: 10, list: [] as ActivityInfo[] }

    componentDidMount(): void {
        getEduAcvities(this.state.page, this.state.pageSize, parseInt(this.props.match?.params?.type ?? "1")).then((res) => {
            this.setState({ list: res.content, total: res.pageCount });
        })

    }
    componentWillReceiveProps(nextProps: Readonly<Partial<RouteComponentProps<{ type: string, name: string, key: string }, StaticContext, unknown>>>, nextContext: any): void {
        getEduAcvities(this.state.page, this.state.pageSize, parseInt(nextProps.match?.params?.type ?? "1")).then((res) => {
            this.setState({ list: res.content, total: res.pageCount });
        })
    }

    html2Text(html: string) {
        var div = document.createElement("div");
        div.innerHTML = html;

        return div.textContent || div.innerText || "";
    }
    render(): ReactNode {

        return (
            <>

                <div className="edu">
                    {
                        this.state.list.map((item, index) => (
                            <>
                                <div className="item">
                                    <div className="img"><img src={item.pic} /></div>
                                    <div className="text">
                                        <h3><span>{item.title}</span></h3>



                                        <p><span>时间</span>：{item.date}</p>
                                        <p><span>地点</span>：{item.address}</p>
                                        <p><span>主办</span>：{item.org}</p>
                                        <p><span>承办</span>：{item.recvorg}</p>
                                        <p><span>协办</span>：{item.assist}</p>
                                        <p><span>参与对象</span>：{item.topeople}</p>
                                        <p className="content">{this.html2Text(item.content)}</p>{/*  dangerouslySetInnerHTML={{ __html: item.content }} */}
                                        <div className="btn enabled" onClick={() => { if (item.url != null && item.url != '') window.location.href = `${item.url}`; }}></div>
                                    </div>

                                </div>
                                <div className="hr" />
                            </>
                        ))
                    }

                    <Pager pageCount={Math.ceil(this.state.total / this.state.pageSize)} pageSize={this.state.pageSize} curpage={0} onNavigatePage={(e) => {
                        this.setState({ page: e });
                        getEduAcvities(e, this.state.pageSize, parseInt(this.props.match?.params?.type ?? "1")).then((res) => {
                            this.setState({ list: res.content, total: res.pageCount });
                        })
                    }}></Pager>

                </div>
            </>
        )
    }
}